'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      position="top-center"
      icons={{
        success: false,
        error: false,
        warning: false,
        info: false,
      }}
      toastOptions={{
        style: {
          borderRadius: '16px',
          padding: '16px',
          fontSize: '14px',
          fontWeight: '500',
          height: 'auto',
        },
        classNames: {
          toast:
            'group toast group-[.toaster]:shadow-lg [&>*:first-child:has(svg)]:hidden [&_svg]:hidden w-full max-w-[484px] !block',
          description: 'group-[.toast]:text-inherit',
          actionButton:
            'bg-black text-white !font-medium !rounded-full !px-4 !py-2 hover:bg-gray-900 !mx-0 !inline-flex !text-sm !mt-4.5 !h-8',
          cancelButton:
            '!border !border-gray-400 !border-solid !bg-transparent !text-black !font-medium !rounded-full !px-4 !py-2 hover:bg-gray-50 !mx-0 !inline-flex !text-sm !mr-2 !mt-4.5 !h-8',
          success:
            'group-[.toaster]:!bg-green-50 group-[.toaster]:!border-green-400 group-[.toaster]:!text-green-800 group-[.toaster]:!border',
          warning:
            'group-[.toaster]:!bg-yellow-50 group-[.toaster]:!border-yellow-400 group-[.toaster]:!text-yellow-800 group-[.toaster]:!border',
          error:
            'group-[.toaster]:!bg-red-50 group-[.toaster]:!border-red-200 group-[.toaster]:!text-[#B91C1C] group-[.toaster]:!border',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
